import { render, staticRenderFns } from "./TableNewShop.vue?vue&type=template&id=02fda72b&scoped=true"
import script from "./TableNewShop.vue?vue&type=script&lang=js"
export * from "./TableNewShop.vue?vue&type=script&lang=js"
import style0 from "./TableNewShop.vue?vue&type=style&index=0&id=02fda72b&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fda72b",
  null
  
)

export default component.exports